import type { NextPage } from 'next';

import { Layout } from 'components/Layout/Layout';
import QuizContentWrapper from 'components/ContentUI/QuizContentWrapper';
import React from 'react';


const EligibilityQuiContentNextPage: NextPage = () => {
  const [groupName, setGroupName] = React.useState('');
  const [pageName, setPageName] = React.useState('');

  return(
    <Layout classNames={['h-background--navy-200']} title='Quiz'>
      <QuizContentWrapper setGroupName={setGroupName} setPageName={setPageName} />
    </Layout>
  )
};

export default EligibilityQuiContentNextPage;
